// extracted by css-extract-rspack-plugin
export default {"snapPill":"jj8WCciXfPcdkrSz"};